import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils";

export const QuestionIcon = ({ className, ...props }: IconProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge("size-5", className)}
    {...props}
  >
    <path
      d="M12.6602 18V18.01M8.77349 10C8.77349 7.79086 10.5137 6 12.6602 6C14.8068 6 16.547 7.79086 16.547 10C16.547 11.8675 15.3035 13.4361 13.6221 13.8766C13.102 14.0128 12.6602 14.4477 12.6602 15M23.3488 12C23.3488 18.0751 18.5634 23 12.6602 23C6.75711 23 1.97168 18.0751 1.97168 12C1.97168 5.92487 6.75711 1 12.6602 1C18.5634 1 23.3488 5.92487 23.3488 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
